import clsx from 'clsx';
import React, { DragEvent, useRef, useState } from 'react';
import { BiSolidCloudUpload } from 'react-icons/bi';

import { Button } from '@/components/button/button';

import styles from './page.module.scss';

interface FileUploadZoneProps {
  onFileSelected: ( file: File ) => void;
}

export default function FileUploadZone( { onFileSelected }: FileUploadZoneProps ) {
  const [ isDragOver, setIsDragOver ] = useState( false );
  const fileInputRef = useRef<HTMLInputElement>( null );

  const handleDragOver = ( e: DragEvent<HTMLDivElement> ) => {
    e.preventDefault();
    setIsDragOver( true );
  };

  const handleDragLeave = ( e: DragEvent<HTMLDivElement> ) => {
    e.preventDefault();
    setIsDragOver( false );
  };

  const handleDrop = ( e: DragEvent<HTMLDivElement> ) => {
    e.preventDefault();
    setIsDragOver( false );

    const file = e.dataTransfer.files[0];
    if ( file && isYamlFile( file ) ) {
      onFileSelected( file );
    }
  };

  const handleBrowseClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = ( e: React.ChangeEvent<HTMLInputElement> ) => {
    const file = e.target.files?.[0];
    if ( file ) {
      onFileSelected( file );
    }
    // Reset so the same file can be re-selected
    if ( fileInputRef.current ) {
      fileInputRef.current.value = '';
    }
  };

  const isYamlFile = ( file: File ): boolean => {
    return file.name.endsWith( '.yaml' ) || file.name.endsWith( '.yml' );
  };

  return (
    <div
      className={ clsx( styles.upload_zone, isDragOver && styles.upload_zone_active ) }
      onDragOver={ handleDragOver }
      onDragLeave={ handleDragLeave }
      onDrop={ handleDrop }
    >
      <BiSolidCloudUpload className={ styles.upload_icon } />
      <p>Drag & drop a YAML file here</p>
      <p className={ styles.upload_or }>or</p>
      <Button variant='primary' onClick={ handleBrowseClick }>
        Browse Files
      </Button>
      <input
        ref={ fileInputRef }
        type='file'
        accept='.yaml,.yml'
        onChange={ handleFileChange }
        style={ { display: 'none' } }
      />
    </div>
  );
}
